<script setup lang="ts">
import type { TabsTriggerProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { TabsTrigger, useForwardProps } from 'reka-ui'
import { cn } from '@/ui/lib/utils'
import { tabsTriggerVariants, type TabsVariants } from '.'

const props = withDefaults(
  defineProps<TabsTriggerProps & { class?: HTMLAttributes['class']; variant?: TabsVariants['variant'] }>(),
  { variant: 'segmented' }
)

const delegatedProps = reactiveOmit(props, 'class', 'variant')

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <TabsTrigger
    data-slot="tabs-trigger"
    :class="cn(tabsTriggerVariants({ variant }), props.class)"
    v-bind="forwardedProps"
  >
    <slot />
  </TabsTrigger>
</template>
